import { CurrencySymbol, CurrencyType } from 'src/constants';

const currencySymbolMap: Partial<Record<CurrencyType, CurrencySymbol>> = {
  [CurrencyType.USD]: CurrencySymbol.USD,
  [CurrencyType.GEL]: CurrencySymbol.GEL,
  [CurrencyType.EUR]: CurrencySymbol.EUR,
};

export const getCurrencySymbol = (val: CurrencyType): CurrencySymbol => {
  return currencySymbolMap[val] as CurrencySymbol;
};
